export {};declare global { interface Window {  } }